module.exports = __webpack_public_path__ + "static/img/icn_apple.bd610c7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icn_apple.svg
// module id = WPRM
// module chunks = 0